import React from "react";
import { useAuthentication } from "@planzone/view-models";
import { useFilesCache } from "@components/cache";
import { Props } from "./types";

function Image({ src, className, fallBack }: Props) {
  const cache = useFilesCache();
  const { token } = useAuthentication().account;
  const [state, setState] = React.useState({
    loadingState: "loadingCache",
    uri: "",
  });
  const prevSrc = React.useRef(src);

  React.useEffect(() => {
    if (prevSrc.current !== src) {
      prevSrc.current = src;
      setState({ loadingState: "loadingCache", uri: "" });
    }
  }, [src]);

  React.useEffect(() => {
    state.loadingState === "loadingCache" &&
      cache
        .get(src)
        .then((blob) =>
          setState({
            loadingState: "startLoading",
            uri: URL.createObjectURL(blob),
          }),
        )
        .catch(() => setState({ loadingState: "none", uri: "" }));
  }, [src, state.loadingState === "loadingCache"]);

  React.useEffect(() => {
    if (state.loadingState !== "none") return;

    const controller = new AbortController();
    const signal = controller.signal;

    fetch(`/docs/files/documents/${src}/content`, {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      signal,
    })
      .then((res) => res.blob())
      .then((blob) => {
        const uri = URL.createObjectURL(blob);

        URL.revokeObjectURL(state.uri);

        try {
          cache.add(src, blob);
        } catch (e) {}

        setState({ loadingState: "startLoading", uri });
      })
      .catch(() => {
        fetch(src, {
          method: "get",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          signal,
        })
          .then((res) => res.blob())
          .then((blob) => {
            const uri = URL.createObjectURL(blob);

            URL.revokeObjectURL(state.uri);

            try {
              cache.add(src, blob);
            } catch (e) {}

            setState({ loadingState: "startLoading", uri });
          })
          .catch(() => {
            setState((s) => ({
              ...s,
              loadingState: "failure",
            }));
          });
      });

    return () => {
      controller.abort();
    };
  }, [src, state.loadingState === "none"]);

  React.useEffect(() => {
    if (state.loadingState === "startLoading") {
      const img = new window.Image();

      img.src = state.uri;

      img.onload = () => {
        setState({ ...state, loadingState: "success" });
        img.remove();
      };
      img.onerror = () => {
        setState({ ...state, loadingState: "failure" });
        img.remove();
      };
    }
  }, [state.loadingState, state.uri]);

  return state.loadingState === "success" ? (
    <img
      className={className}
      src={state.uri}
      alt=""
      onError={() => console.log("TEST")}
    />
  ) : (
    <>{fallBack}</>
  );
}

export { Image };
